import {Helmet} from "react-helmet-async";

const BASE_URL = "https://jogacompix.com";
const DEFAULT_TITLE = "Jogacompix - Cassino ao vivo, apostas e jogos online";
const DEFAULT_DESCRIPTION =
  "Jogacompix - cassino ao vivo, caça-níqueis, apostas esportivas e minijuegos.";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

const SEO = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  image = DEFAULT_IMAGE,
  noIndex = false,
}) => {
  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="title"
        content={title}
      />
      <meta
        name="description"
        content={description}
      />
      <link
        rel="canonical"
        href={canonicalUrl}
      />
      {noIndex && (
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      )}

      {/* Open Graph / Facebook */}
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:url"
        content={canonicalUrl}
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:description"
        content={description}
      />
      <meta
        property="og:site_name"
        content="Jogacompix"
      />
      <meta
        property="og:image"
        content={image}
      />

      {/* Twitter */}
      <meta
        property="twitter:card"
        content="summary_large_image"
      />
      <meta
        property="twitter:url"
        content={canonicalUrl}
      />
      <meta
        property="twitter:title"
        content={title}
      />
      <meta
        property="twitter:description"
        content={description}
      />
      <meta
        property="twitter:image"
        content={image}
      />
    </Helmet>
  );
};

export default SEO;
